import React from 'react';

import { TabPage } from '../../components/tabs';
import { Render } from '../../components';

import { InsuredRequiredFields, VehicleRequiredFields } from './containers';
import { useInsuranceType } from '../product/hooks';
import { useActiveAccount } from '../../shared/activeAccount';

export default function ProductRequiredFields({ product }) {
  const { insuranceType } = useInsuranceType({ productId: product?.id });
  const {
    roleIsBelow,
    typeIsBelow,
    ROLES: { COLLABORATOR },
    TYPES: { BROKER }
  } = useActiveAccount();

  // require the state_of_registration field if there are one or more insurance type state fees
  const requireStateOfRegistration = insuranceType?.stateFees?.length > 0;
  const insuranceTypeRequiresVehicle = insuranceType?.requireVehicle;

  // if role is exposure manager or policy manager, then role is below collaborator
  const roleBelowCollaborator = roleIsBelow(COLLABORATOR);
  const typeBelowBroker = typeIsBelow(BROKER);

  return (
    <TabPage title="Required Fields" showBackButton>
      <InsuredRequiredFields
        productId={product?.id}
        roleBelowCollaborator={roleBelowCollaborator}
        typeBelowBroker={typeBelowBroker}
      />

      <Render if={insuranceTypeRequiresVehicle}>
        <VehicleRequiredFields
          productId={product?.id}
          requireStateOfRegistration={requireStateOfRegistration}
          roleBelowCollaborator={roleBelowCollaborator}
          typeBelowBroker={typeBelowBroker}
        />
      </Render>
    </TabPage>
  );
}
